/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in app
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash';
import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import repository from '@/repository';
import helpers from '@/utils/helpers';

const isPublic = sessionStorage.getItem('isPublic');
export default {
    namespaced: true,
    state: {
        isLoading: false,
        isForceLoading: false,
        isNoLoading: false,
        countLoading: 0,
        isShowHeaderError: false,
        headerErrors: [],
        isShowModalMessage: false,
        modalMessage: {
            type: MSG_TYPE.ERROR,
            title: '',
            content: '',
            okText: 'はい',
            cancelText: 'いいえ',
            callback: () => {}
        },
        loginScreen: isPublic === 'true' ? '/public/login' : '/private/login',
        homeScreen: isPublic === 'true' ? '/gs/gs0030i' : '/gs/gs0510v',
        isPublic: isPublic === 'true',
        screenId: 'cm0011i',
        isMobile: helpers.isMobile(),
        user: helpers.getUserFromToken(),
        // eslint-disable-next-line prettier/prettier, no-undef
        menuPermission: !sessionStorage.getItem('menuPermission') ? [] : JSON.parse(Base64.decode(sessionStorage.getItem('menuPermission'))),
        notification: {},
        noNeedGetAppState: false,
        onApiError: null
    },
    mutations: {
        showLoading(state) {
            state.isLoading = true;
        },
        hideLoading(state) {
            state.isLoading = false;
        },
        showForceLoading(state) {
            state.isForceLoading = true;
        },
        hideForceLoading(state) {
            state.isForceLoading = false;
        },
        showHeaderError(state, errors) {
            state.isShowHeaderError = true;
            state.headerErrors = errors;
        },
        hideHeaderError(state) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
            // eslint-disable-next-line no-undef
            $(`.item-error`).RemoveError();
        },
        showModalMessage(state, message) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
            state.isShowModalMessage = true;
            if (message) {
                if (message.type) {
                    state.modalMessage.type = message.type;
                } else {
                    state.modalMessage.type = MSG_TYPE.ERROR;
                }
                state.modalMessage.title = message.title;
                if (message.content) {
                    state.modalMessage.content = message.content;
                } else {
                    state.modalMessage.content = messages.E999;
                }
                if (message.okText) {
                    state.modalMessage.okText = message.okText;
                } else {
                    state.modalMessage.okText = 'はい';
                }
                if (message.cancelText) {
                    state.modalMessage.cancelText = message.cancelText;
                } else {
                    state.modalMessage.cancelText = 'いいえ';
                }
                state.modalMessage.callback = message.callback;
            } else {
                state.modalMessage = {
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E999,
                    content: messages.E999,
                    okText: 'はい',
                    cancelText: 'いいえ',
                    callback: () => {}
                };
            }
        },
        updateShowModalMessage(state, value) {
            state.isShowModalMessage = value;
        },
        hideModalMessage(state) {
            state.isShowModalMessage = false;
            setTimeout(() => {
                state.modalMessage = {
                    type: MSG_TYPE.ERROR,
                    title: '',
                    content: '',
                    okText: 'はい',
                    cancelText: 'いいえ',
                    callback: () => {}
                };
            }, 250);
        },
        setNoNeedGetAppState(state, data) {
            state.noNeedGetAppState = data;
        },
        setAppState(state, data) {
            state.menuPermission = data.permission;
            state.user = data.user;
            state.notification = data.notification;
            const Pj0040i = _.find(state.menuPermission, (x) => {
                return x.機能ID == 'Pj0040i';
            });
            if (Pj0040i) {
                state.menuPermission.push({
                    機能ID: 'Pj0010i',
                    機能名称: 'プロジェクトの管理',
                    上司権限: Pj0040i.上司権限,
                    利用者権限: Pj0040i.利用者権限
                });
            }
            const Gs0193v = _.find(state.menuPermission, (x) => {
                return x.機能ID == 'Gs0193v';
            });
            if (Gs0193v) {
                state.menuPermission.push({
                    機能ID: 'Gm0050v',
                    機能名称: '年次有給休暇の状況',
                    上司権限: Gs0193v.上司権限,
                    利用者権限: Gs0193v.利用者権限
                });
            }
            const Gs0050v = _.find(state.menuPermission, (x) => {
                return x.機能ID == 'Gs0050v';
            });
            if (Gs0050v) {
                state.menuPermission.push({
                    機能ID: 'Gm0070i',
                    機能名称: '承認待ち一覧',
                    上司権限: Gs0050v.上司権限,
                    利用者権限: Gs0050v.利用者権限
                });
            }
            const Gs0711v = _.find(state.menuPermission, (x) => {
                return x.機能ID == 'Gs0711v';
            });
            if (Gs0711v) {
                state.menuPermission.push({
                    機能ID: 'Gm0080v',
                    機能名称: 'アラート一覧',
                    上司権限: Gs0711v.上司権限,
                    利用者権限: Gs0711v.利用者権限
                });
            }
            const Gs0060v = _.find(state.menuPermission, (x) => {
                return x.機能ID == 'Gs0060v';
            });
            if (Gs0060v) {
                state.menuPermission.push({
                    機能ID: 'Gm0090v',
                    機能名称: '勤怠モニター',
                    上司権限: Gs0060v.上司権限,
                    利用者権限: Gs0060v.利用者権限
                });
            }
            sessionStorage.setItem(
                'menuPermission',
                // eslint-disable-next-line no-undef
                Base64.encode(JSON.stringify(state.menuPermission))
            );
        },
        resetAppState(state) {
            state.menuPermission = [];
            state.user = {};
            state.notification = {};
            sessionStorage.removeItem('menuPermission');
        },
        setScreenId(state, id) {
            state.screenId = id;
        },
        setNoLoading(state, val) {
            state.isNoLoading = val;
        },
        increaseCountLoading(state) {
            state.countLoading += 1;
        },
        decreaseCountLoading(state) {
            state.countLoading -= 1;
            if (state.countLoading < 0) {
                state.countLoading = 0;
            }
        },
        setMobile(state) {
            state.isMobile = helpers.isMobile();
        },
        setPrivateOrPublic(state, isPublic) {
            if (`${isPublic ?? ''}` != 'true') {
                this.loginScreen = '/private/login';
                this.homeScreen = '/gs/gs0510v';
                this.isPublic = false;
            } else {
                this.loginScreen = '/public/login';
                this.homeScreen = '/gs/gs0030i';
                this.isPublic = true;
            }
        },
        setOnApiError(state, callback) {
            state.onApiError = callback;
        }
    },
    actions: {
        getAppState(context, input) {
            try {
                repository.getAppState({}).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setAppState', data.Data ?? {});
                        if (input?.callback) {
                            input.callback();
                        }
                    }
                });
            } catch (e) {
                console.log('Action getAppState: ' + e.message);
            }
        },
        getTime(context, callback) {
            repository.getCurrentTime().then((res) => {
                const { data } = res;
                if (data.Code === 200) {
                    callback(data.Data.time);
                }
            });
        }
    }
};
